module.exports = require('./helpers/bundle-url').getBundleURL('7XW1A') + "logo.c5857b8b.svg";